import * as cn from './class'
import * as strings from './string'

export { cn, strings }
